import { Component, OnInit } from '@angular/core';
import {  FormControl, FormGroup,  Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import {
  debounceTime, distinctUntilChanged, switchMap
} from 'rxjs/operators';

import { Entitlement, Modules } from './entitlement.model';
import { EntitlementApiService } from './entitlement.service';

@Component({
  selector: 'app-entitlement',
  templateUrl: './entitlement.component.html',
  styleUrls: [ './entitlement.component.css' ]
})
export class EntitlementComponent implements OnInit {
  private searchClients = new Subject<string>();
  modules$:   Modules[];
  searchItems = {clientId: ''};

  searchForm: FormGroup;
  serverError: boolean = false;
  connectionError: boolean=false;
  isLoading: boolean=false;
  constructor(private entitlementService: EntitlementApiService) {
    console.log('entitlement component');
  }

  // Push a search term into the observable stream.
  search(clientId: string): void {
    clientId = clientId.trim();
    if (!clientId) { return; }

    this.isLoading = true;
    this.serverError = false;
    this.connectionError = false;
    this.modules$ = null;
    this.searchClients.next(clientId);
  }

  ngOnInit(): void {
    this.serverError = false;

    this.searchForm = new FormGroup({
      'clientId': new FormControl(this.searchItems.clientId, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ])
    });

    this.searchClients.pipe(
      switchMap((clientId) => this.entitlementService.searchEntitlements(clientId))
    ).subscribe(
     entry => this.handleResponse(entry)
   );
  }
  handleResponse(result) {
    if (result.ok === false) {
      if (result.status === 0) {
        this.connectionError = true;
      } else {
        this.serverError = true;
      }
    } else {
      this.modules$ = result;
      this.serverError = false;
      this.connectionError = false;
    }

    this.isLoading = false;
  }
  resetValidation(value) {
    this.connectionError = false;
    this.serverError = false;
  }
  get clientId() { return this.searchForm.get('clientId'); }
}



// WEBPACK FOOTER //
// ./src/app/entitlement/entitlement.component.ts